import React from 'react'
import Contactform from '../Components/Contactform'
import TestimonialSlider from '../Components/TestimonialSlider '
import { HashLink } from 'react-router-hash-link'
import CookieBanner from '../Components/CookieBanner'

function Home() {
  return (
    <div>
       < CookieBanner />
        {/*!-- Bannner section starts --*/}
        <section className="banner position-relative pb-0">
            <div className="container">
                <div className="inner-banner position-relative text-white ">
                    <div className="row">
                        <div className="col-lg-6 order-2 order-lg-1 left-img-class">
                            <div className="banner-left text-center pb-lg-5 p-md-0">
                                <div className="banner-image">
                                    <img src="assets/images/team/4.png" alt="banner-image" className="w-50"/><br/>
                                </div>
                                 <div className="countdown">
                                    <div className="countdown-inner d-flex w-100 bg-transparent justify-content-center position-relative z-2 h-100">
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-6 order-1 order-lg-2">
                            <div className="banner-right  ms-2 text-lg-start pb-8">
                            <div className="banner-title pb-3">
                                <h1 className="text-white text-left">Wydarzenia,</h1>
                                <h4 className="text-white pb-3 text-left">które wspierają wzrost<br />i&nbsp;budują relacje</h4>
                            </div>
                            <div className="event-discription">
                                <p className="pb-4 m-0">Pomagamy startupom technologicznym i firmom z sektora MŚP projektować i realizować wydarzenia, które zwiększają widoczność marki, wspierają sprzedaż i przyciągają strategicznych partnerów.</p>
                                <p className='pb-4 m0'>Od spotkań z inwestorami po konferencje dla setek uczestników – wiemy, jak zorganizować wydarzenie, które ma znaczenie.</p>
                                <div className="banner-button">
                                <div className="row">
                                    <div className="col-lg-8 col-md-6 text-center">
                                        <HashLink to="#contact"  className="btn-banner">Umów bezpłatną konsultację</HashLink>
                                    </div> 
                                </div>
                                </div>
                            </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="wave overflow-hidden position-absolute w-100 z-0">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1000 100" preserveAspectRatio="none"
                    className="d-block position-relative">
                    <path className="elementor-shape-fill" d="M790.5,93.1c-59.3-5.3-116.8-18-192.6-50c-29.6-12.7-76.9-31-100.5-35.9c-23.6-4.9-52.6-7.8-75.5-5.3
                    c-10.2,1.1-22.6,1.4-50.1,7.4c-27.2,6.3-58.2,16.6-79.4,24.7c-41.3,15.9-94.9,21.9-134,22.6C72,58.2,0,25.8,0,25.8V100h1000V65.3
                    c0,0-51.5,19.4-106.2,25.7C839.5,97,814.1,95.2,790.5,93.1z"></path>
                </svg>
            </div>
        </section>
        {/*--Banner Section end--*/}

 {/*--For startups Section start--*/}

<section id="offer" className="overview pb-0">
  <div className="container">
    <div className="inner-overview pb-10 position-relative">
      <div className="row justify-content-between">

        <div className="col-lg-6 order-1 order-lg-1 pt-4 pt-lg-0">
          <div className="overview-img">
            <div className="row align-items-center">
              <div className="col-6 p-0">
                <div className="container-img-left">
                  <div className="img-left-1 w-80 mb-2 float-end">
                    <img className="w-100 rounded" src="assets/images/group/1.png" alt="group-image"/>
                  </div>
                  <div className="img-left-2 w-100">
                    <img src="assets/images/group/2.png" alt="group-image" className="w-100 rounded"/>
                  </div>
                </div>
              </div>
              <div className="col-6">
                <div className="container-img-right">
                  <img src="assets/images/group/3.png" alt="group-image" className="w-100 rounded"/>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="col-lg-5 order-0 order-lg-0">
          <div className="overview-left text-left text-lg-start">
            <div className="overview-title pb-4">
              <p className="mb-1">Dla startapów</p>
              <h2 className="mb-2">Maksymalny efekt z&nbsp;każdego wystąpienia</h2>
              <p><span className='fw-bold'>Wyzwanie<br /></span>W świecie dynamicznego wzrostu i konkurencji, udział w wydarzeniach nie może być przypadkowy – to narzędzie do pozyskiwania inwestorów, partnerstw i przewagi rynkowej.</p>
              <p><span className='fw-bold'>Nasze podejście:<br /></span>Projektujemy obecność startupów na kluczowych wydarzeniach – od pitch day, przez targi i konferencje, po spotkania z funduszami VC – z dbałością o cel, spójność i rezultaty.</p>
              <p><span className='fw-bold'>Korzyści biznesowe:</span>
                <ul>
                  <li>Skuteczne pozyskiwanie leadów i kontaktów inwestorskich</li>
                  <li>Profesjonalna obecność na arenie międzynarodowej</li>
                  <li>Odciążenie zespołu operacyjnie i strategicznie</li>
                </ul>
              </p>              
              <p><span className='fw-bold'>Zasięg:<br /></span>Realizujemy projekty m.in. na Fibo, Dubai Active, CosmoPharm, WarsawPack. Współpracujemy z lokalnymi partnerami w całej Europie, zapewniając płynność operacyjną i znajomość lokalnych realiów.</p>        
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</section>


        {/*--For sturtups Section end--*/}

        {/*--For small and medium enterprises section start--*/}
        <section className="overview pb-0">
  <div className="container">
    <div className="inner-overview pb-10 position-relative">
      <div className="row justify-content-between">
        <div className="col-lg-6 order-1 order-lg-0 pt-4 pt-lg-0 align-self-center">
          <div className="overview-img">
            <div className="row align-items-center">
              <div className="col-6 col-md-5 p-0">
                <div className="container-img-left">
                  <img src="assets/images/group/6.png" alt="group-image" className="w-100 rounded" />
                </div>
              </div>
              <div className="col-6 col-md-7">
                <div className="container-img-right mb-2">
                  <div className="img-right-1 float-start w-100 mb-2">
                    <img src="assets/images/group/4.png" alt="group-image" className="w-80 rounded" />
                  </div>
                  <div className="img-right-2">
                    <img src="assets/images/group/5.png" alt="group-image" className="w-100 rounded" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-lg-5 order-0 order-lg-1">
          <div className="overview-left text-left text-lg-start">
            <div className="overview-title pb-4">
              <p className="mb-1">Dla Małych i Średnich Przedsiębiorstw</p>
              <h2 className="mb-2">Wydarzenia, które przekładają się na wyniki</h2>
              <p><span className="fw-bold">Wyzwanie<br /></span>Właściciele firm z sektora MŚP potrzebują rozwiązań, które realnie wspierają sprzedaż i budują lojalność klientów – bez konieczności angażowania całego zespołu w organizację wydarzenia.</p>
              <p><span className="fw-bold">Nasze podejście:<br /></span>Projektujemy wydarzenia odpowiadające na konkretne cele biznesowe – od generowania leadów, przez relacje z kluczowymi klientami, po wzmocnienie pozycji rynkowej.</p>
              <p><span className="fw-bold">Korzyści biznesowe:</span>
                <ul>
                  <li>Wzrost liczby wartościowych kontaktów</li>
                  <li>Silniejsze relacje z obecnymi klientami i partnerami</li>
                  <li>Kompleksowa organizacja – bez obciążania Twojego zespołu.</li>
                </ul>
              </p>              
              <p><span className="fw-bold">Sprawdzone formaty:</span>
                <ul>
                  <li>Śniadania biznesowe i warsztaty eksperckie</li>
                  <li>Kameralne kolacje VIP dla strategicznych klientów</li>
                  <li>Obecność targowa wspierająca sprzedaż</li>
                </ul>
              </p>        
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</section>

        {/*--For small and medium enterprises section end--*/}

        {/*--Complex organization section start--*/}

<section id="offer" className="overview pb-0">
  <div className="container">
    <div className="inner-overview pb-10 position-relative">
      <div className="row justify-content-between">

        <div className="col-lg-6 order-1 order-lg-1 pt-4 pt-lg-0">
          <div className="overview-img">
            <div className="row align-items-center">
              <div className="col-6 p-0">
                <div className="container-img-left">
                  <div className="img-left-1 w-80 mb-2 float-end">
                    <img className="w-100 rounded" src="assets/images/group/7.png" alt="group-image"/>
                  </div>
                  <div className="img-left-2 w-100">
                    <img src="assets/images/group/8.png" alt="group-image" className="w-100 rounded"/>
                  </div>
                </div>
              </div>
              <div className="col-6">
                <div className="container-img-right">
                  <img src="assets/images/group/9.png" alt="group-image" className="w-100 rounded"/>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="col-lg-5 order-0 order-lg-0">
          <div className="overview-left text-left text-lg-start">
            <div className="overview-title pb-4">
                       <p className="mb-1">Konferencje</p>
                        <h2 className="mb-2">Kompleksowa organizacja wydarzeń do 500&nbsp;uczestników</h2>
                        <p>Jeśli planujesz wydarzenie większej skali, potrzebujesz partnera, który łączy logistykę z merytoryką.</p>
                        <p>Organizujemy konferencje biznesowe dla nawet 500 osób – z pełnym wsparciem od strategii po realizację. Pracujemy zarówno z branżami wymagającymi pod kątem treści (m.in. prawnicy, rynek wycen), jak i z firmami szukającymi wyrazistego formatu wydarzenia dla klientów lub pracowników</p>
                        <p><span className='fw-bold'>Zakres usług obejmuje:</span><ul>
                            <li>wybór lokalizacji i partnerów technicznych</li>
                            <li>oprawę wizualną, komunikacyjną i logistyczną,</li>
                            <li>współpracę z prelegentami oraz moderację,</li>
                            <li>komunikację z uczestnikami i obsługę na miejscu,</li>
                            <li>raportowanie i ewaluację efektów.</li>
                            </ul></p>   
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</section>

        {/*--Complex organization section end--*/}

        {/*--Features Section start--*/}
        <section id='why-us' className="feature text-white position-relative z-0 start-0">
            <div className="overlay z-n1">
            </div>
            <div className="section-title w-lg-100 m-auto text-center pb-8">
                        <h2 className="mb-1 text-white">Dlaczego warto z&nbsp;nami współpracować?</h2>
                        <p className="m-0">Jesteśmy partnerem strategicznym, nie tylko wykonawcą.<br />Pracujemy w modelu 
                             <span className='fw-bold'> „cel, działanie, efekt”</span>, zapewniając pełne wsparcie na każdym etapie procesu.</p>
                    </div>
            <div className="container">
                <div className="feature-inner">
               
                    <div className="feature-lists pt-8">
                        <div className="row g-4">
                            <div className="col-lg-4 col-md-6 d-flex">
                            <div className="feature-box py-7 px-6 rounded text bg-black bg-opacity-25 h-100 w-100 d-flex flex-column">
                                <div className="feature-box-icon mb-4">
                                   <div className="icon-wrapper bg-pink rounded-circle d-flex justify-content-center align-items-center">
                                        <img
                                            src="assets/images/icon/5.svg"
                                            alt="icon"
                                            className="svg-icon"
                                            style={{ maxHeight: "40px" }}
                                        />
                                    </div>
                                </div>
                                <div className="feature-box-info ">
                                    <h5 className="text-white mb-2">Strategiczne podejście</h5>
                                    <small>Pracujemy w modelu &#34;cel 	&#8594; działanie &#8594; efekt&#34;, skupiając się na Twoich celach biznesowych.</small>
                                </div>
                            </div>
                            </div>
                            <div className="col-lg-4 col-md-6 d-flex">
                            <div className="feature-box py-7 px-6 rounded text bg-black bg-opacity-25 h-100 w-100 d-flex flex-column">
                                <div className="feature-box-icon mb-4">
                                    <div className="icon-wrapper bg-pink rounded-circle d-flex justify-content-center align-items-center">
                                        <img
                                            src="assets/images/icon/6.svg"
                                            alt="icon"
                                            className="svg-icon"
                                            style={{ maxHeight: "40px" }}
                                        />
                                    </div>
                                </div>
                                <div className="feature-box-info">
                                    <h5 className="text-white mb-2">Transparentna Komunikacja</h5>
                                    <small>Cenimy jasne zasady, otwarty dialog i szybkie tempo pracy.</small>
                                </div>
                            </div>
                            </div>
                            <div className="col-lg-4 col-md-6 d-flex">
                            <div className="feature-box py-7 px-6 rounded text bg-black bg-opacity-25 h-100 w-100 d-flex flex-column">
                                <div className="feature-box-icon mb-4">
                                    <div className="icon-wrapper bg-pink rounded-circle d-flex justify-content-center align-items-center">
                                        <img
                                            src="assets/images/icon/7.svg"
                                            alt="icon"
                                            className="svg-icon"
                                            style={{ maxHeight: "40px" }}
                                        />
                                    </div>
                                </div>
                                <div className="feature-box-info">
                                    <h5 className="text-white mb-2">Kompleksowe Zarządzanie</h5>
                                    <small>Zapewniamy pełną obsługę: od koncepcji, przez logistykę, aż po produkcję.</small>
                                </div>
                            </div>
                            </div>
                            <div className="col-lg-4 col-md-6 d-flex">
                            <div className="feature-box py-7 px-6 rounded text bg-black bg-opacity-25 h-100 w-100 d-flex flex-column">
                                <div className="feature-box-icon mb-4">
                                    <div className="icon-wrapper bg-pink rounded-circle d-flex justify-content-center align-items-center">
                                        <img
                                            src="assets/images/icon/8.svg"
                                            alt="icon"
                                            className="svg-icon"
                                            style={{ maxHeight: "40px" }}
                                        />
                                    </div>
                                </div>
                                <div className="feature-box-info">
                                    <h5 className="text-white mb-2">Mierzalne Rezultaty</h5>
                                    <small>Koncentrujemy się na efektach, które możesz zmierzyć i ocenić.</small>
                                </div>
                            </div>
                            </div>
                            <div className="col-lg-4 col-md-6 d-flex">
                            <div className="feature-box py-7 px-6 rounded text bg-black bg-opacity-25 h-100 w-100 d-flex flex-column">
                                <div className="feature-box-icon mb-4">
                                   <div className="icon-wrapper bg-pink rounded-circle d-flex justify-content-center align-items-center">
                                        <img
                                            src="assets/images/icon/9.svg"
                                            alt="icon"
                                            className="svg-icon"
                                            style={{ maxHeight: "40px" }}
                                        />
                                    </div>
                                </div>
                                <div className="feature-box-info">
                                    <h5 className="text-white mb-2">Doświadczenie i Jakość</h5>
                                    <small>Organizujemy wydarzenia do 500 osób, skupiając się na jakości, która ma kluczowe znaczenie.</small>
                                </div>
                            </div>
                            </div>
                            <div className="col-lg-4 col-md-6 d-flex">
                            <div className="feature-box py-7 px-6 rounded text bg-black bg-opacity-25 h-100 w-100 d-flex flex-column">
                                <div className="feature-box-icon mb-4">
                                    <div className="icon-wrapper bg-pink rounded-circle d-flex justify-content-center align-items-center">
                                        <img
                                            src="assets/images/icon/10.svg"
                                            alt="icon"
                                            className="svg-icon"
                                            style={{ maxHeight: "40px" }}
                                        />
                                    </div>
                                </div>
                                <div className="feature-box-info">
                                    <h5 className="text-white mb-2">Wsparcie na każdym etapie</h5>
                                    <small>Zapewniamy pełne wsparcie operacyjne i kreatywne w całym procesie.</small>
                                </div>
                            </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>    
        </section>
        {/*--Features Section end--*/}

        {/*--Process Section start--*/}
        <section>
            <div className='container'>
                <div className='d-flex flex-column justify-content-center'>
                    <div className="section-title w-lg-60 m-auto text-center pb-8">
                        <h2 className="mb-1">Proces współpracy</h2>
                        <p className="m-0">Nasz proces współpracy w <span className='fw-bold'>4 krokach</span>, który zdejmie z Ciebie cały ciężar organizacji.</p>
                    </div>
                </div>
                <div className='d-flex flex-row justify-content-around align-items-stretch flex-wrap'>
                    <div className='d-flex flex-column align-items-center justify-content-start process-item' >
                        <img className="mb-5" style={{maxHeight: "60px", width: "auto" }} src="assets/images/icon/1.svg" alt="group-image"/>
                        <h5 className="mb-1 text-center"><span className='pink'>Krok 1</span> - Analiza</h5>
                        <p className='text-center'style={{width: "200px"}}>Zaczynamy od dogłębnego zrozumienia Twoich potrzeb i celów biznesowych.</p>
                    </div>
                    <div className='d-flex flex-column align-items-center justify-content-start process-item'>
                        <img className="mb-5" style={{maxHeight: "60px", width: "auto" }} src="assets/images/icon/2.svg" alt="group-image"/>
                        <h5 className="mb-1 text-center"><span className='pink'>Krok 2</span> - Koncepcja<br/>i Wycena</h5>
                        <p className='text-center'style={{width: "200px"}}>Opracowujemy dopasowaną strategię wydarzenia wraz z transparentnym kosztorysem.</p>
                    </div>
                     <div className='d-flex flex-column align-items-center justify-content-start process-item' >
                        <img className="mb-5" style={{maxHeight: "60px", width: "auto" }} src="assets/images/icon/3.svg" alt="group-image"/>
                        <h5 className="mb-1 text-center"><span className='pink'>Krok 3</span> - Realizacja</h5>
                        <p className='text-center'style={{width: "200px"}}>Bierzemy na siebie pełne wsparcie operacyjne i kreatywne, abyś Ty mógł skupić się na gościach.</p>
                    </div>
                     <div className='d-flex flex-column align-items-center justify-content-start process-item' >
                       <img className="mb-5" style={{maxHeight: "60px", width: "auto" }} src="assets/images/icon/4.svg" alt="group-image"/>
                        <h5 className="mb-1 text-center"><span className='pink'>Krok 4</span> - Ewaluacja</h5>
                        <p className='text-center'style={{width: "200px"}}>Po wydarzeniu analizujemy efekty i dajemy Ci konkretne rekomendacje na przyszłość.</p>
                    </div>
                </div>
            </div>
        </section>
        {/*--Process Section end--*/}

        {/*--Testimonials Section start--*/}
        <section id="opinions" className="testimonial bg-lightgrey">
            <div className="container">
                <div className="section-title w-lg-60 m-auto text-center pb-5">
                    <h2 className="mb-1">Co mówią o nas nasi klienci?</h2>
                    <p className="m-0">Bardzo zależy nam na Waszej satysfakcji, dlatego Wasza opinia jest <br /> dla nas kluczowa w dalszym rozwoju.
                    </p>
                </div>
                <TestimonialSlider />
            </div>
        </section>
        {/*--Testimonials Section end--*/}

        <section id="contact" className="contact">
            <div className="container">
                <div className="contact-inner text-md-start">
                    <div className="row g-md-5 gy-5 align-items-center">
                        <div className="col-lg-4 col-md-4">
                            <div className="contact-event-info p-8 text-white h-100 rounded " style={{backgroundColor:"#162146"}}>
                                <img src="assets/images/logo/2.png" alt="banner-image" className="w-80 pb-8 d-block mx-auto"/>
                                <div className="event-venue">
                                    <h4 className="text-white pb-2">MTC EVENTS SP Z O O</h4>
                                </div>
                                <div className="reception-info">
                                    <p className="text-white"><span className='fw-bold'>Telefon:</span> +48 516 156 423</p>
                                </div> 
                                <div className="reception-info">
                                    <p className="text-white"><span className='fw-bold'>E-mail:</span> biuro@mtcevents.pl</p>
                                </div>
                                 <div className="reception-info">
                                    <p className="text-white"><span className='fw-bold'>Adres:</span> ul. ALEJA JANA PAWŁA II 25,00-854 WARSZAWA</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-8 col-md-7">
                            <div className="contact-form">
                                <div className="form-title mb-4 text-center">
                                <h2 className="mb-1">Skontaktuj się <span className="pink">z&nbsp;nami</span></h2>
                                <p>Chcesz zaprojektować wydarzenie, które będzie wspierać Twoje cele biznesowe?</p>
                                </div>
                                <div className="form">
                                    <Contactform />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
  )
}

export default Home